const GET_ALL_NOTIFICATIONS = "v3/partner/:partnerId/fetchNotifications";
const GET_UNREAD_NOTIFICATIONS =
  "v3/partner/:partnerId/fetchUnreadNotifications";
const GET_USER_PARTNER_INFORMATION = "v3/user/:uid/fetchB2bUser";
const MARK_ALL_NOTIFICATIONS_AS_READ = "v3/partner/:partnerId/markAllAsRead";

export {
  GET_ALL_NOTIFICATIONS,
  GET_UNREAD_NOTIFICATIONS,
  GET_USER_PARTNER_INFORMATION,
  MARK_ALL_NOTIFICATIONS_AS_READ,
};
